import { REPORT_TYPES } from "../../../constants/app-constant";
import { formatDataByRanking } from "./format-data-by-ranking";
import { formatDataByTonality } from "./format-data-by-tonality";
import { formatDataByTrend } from "./format-data-by-trend";

const {
  SOV_NOA_TREND,
  SOV_MAV_TREND,
  SOV_CCM_TREND,
  SOV_WC_TREND,
} = REPORT_TYPES;

export const formatDataBySOV = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  const isTrend =
    report_type === SOV_NOA_TREND ||
    report_type === SOV_MAV_TREND ||
    report_type === SOV_CCM_TREND ||
    report_type === SOV_WC_TREND;
  if (isTrend) {
    return formatDataByTrend(d, graph_type, isLineGraph, type, report_type);
  } else {
    return formatDataByRanking(d, graph_type, isLineGraph, type, report_type);
  }
};
